<template>
  <div>How to buy page</div>
</template>

<script>
export default {
  name: 'HowToBuy',
}
</script>